<template>

  <div v-bind:class="get_width('badge')" v-bind:key="pos[0]">
    <div class="hit-panel hit-panel-primary">
      <div class="hit-panel-heading">
        <div class="hit-pull-right">{{ $tc("message.badge", 1) }}</div>
        <span class="handle"><i class="hit-glyphicon hit-glyphicon-move"></i></span>
      </div>
      <div class="hit-panel-body" style="background-color: #eee;">
        <div class="hit-form-group hit-text-center">

          <hit_badge v-bind:key="curr_key+'_badge'" class="hit-html-html" :design="design.badge" :survey='get_badge()'/>

        </div>
      </div>
      <div class="hit-panel-footer hit-text-right">
        <div class="hit-row">
          <div class="hit-col-md-6">
            <select class="hit-form-control" v-model="design.badge">
              <option v-for="name in Object.keys($store.getters.badges)" v-bind:value="name">{{ name }}</option>
            </select>
          </div>
          <div class="hit-col-md-6">
            <select class="hit-form-control" v-bind:value="width['badge']" v-on:change="function(val){ set_width(val.target.value, 'badge') }">
              <option v-for="col in [12,11,10,9,8,7,6,5,4,3,2,1]" v-bind:value="col">{{ Math.round((col/12 * 100)) }}%</option>
            </select>
          </div>
        </div>
      </div>

    </div>
  </div>

</template>

<script>

export default{

  props: {
    width: Object,
    survey: Object,
    set_width: Function,
    design: Object,
    curr_key: [String, Number],
    get_width: Function,
    get_badge: Function,
    pos: Array

  }
}

</script>

<style scoped>

.handle{
  cursor: pointer;
}

</style>
